import React, { useEffect, useState } from 'react'
import Popup from '../Popup/BasePopup'
import Ludo from '../../images/Ludo1.png';
import Button from '../CommonFields/Button';
import { toastError, toastSuccess } from '../../Utilities/toast';
import { favouriteGameList } from '../../api/game.api';
import { t } from 'i18next';
import { alreadyfavouriteGame, updatefavouriteGame } from '../../api/account.api';
import ListLoader from '../Common/ListLoader';
import { base_apis } from '../../config/url';
const Favourite = ({ isOpen, title, onClose }) => {
    const [favGame, setFavGames] = useState([]);
    const [gameList, setGames] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [isSaveBtnDisable, setIsSaveBtnDisable] = useState(false);
    
    useEffect(() => {
        fetchFavGamesList();
    }, [])
    useEffect(() => {
        if (gameList?.length > 0)
            fetchAlreadyFavGames();
    }, [gameList])

    const fetchFavGamesList = async () => {
        try {
            setLoading(true)
            const response = await favouriteGameList();
            setLoading(false)
            if (response?.success && response?.data) {
                setGames(response?.data)
            }
        } catch (error) {
            setLoading(false)
        }
    }
    const fetchAlreadyFavGames = async () => {
        try {
            const response = await alreadyfavouriteGame();
            if (response?.success && response?.favoriteGames) {
                let temp = [];
                response?.favoriteGames?.forEach(favGameId => {
                    temp.push(gameList.findIndex(game => game?._id === favGameId));
                });
                setActive(temp)
                setFavGames(response?.favoriteGames)
            }
        } catch (error) {
        }
    }
    const [active, setActive] = useState([])
    const handlerClick = (ind) => {
        setActive((prev) => {
            if (active.includes(ind)) {
                return prev.filter((i) => i !== ind)
            }
            else {
                return [
                    ...active,
                    ind
                ]
            }
        })
    }
    const handlerSubmit = async () => {

        if ( favGame?.length ===0) {
            if (active.length ===0) {
                toastError(t('moreMenu.fav_games.error_please_select_at_least_one_game'))
                return;
            }
        }
        // else{
        //     if (active.length === 0) {
        //         toastError(t('moreMenu.fav_games.error_please_select_at_least_one_game'))
        //         return;
        //     }
        // }
        setIsSaveBtnDisable(true);
        try {
            const data = active.map((index) => { return gameList.at(index); })
            var response = await updatefavouriteGame({ favoriteGames: data });
            if (response?.success) {
                toastSuccess(t('moreMenu.fav_games.success_favourite_game_update_successfully'))
                onClose(true)
            }
            else {
                setIsSaveBtnDisable(false);
            }
        } catch (error) {
            setIsSaveBtnDisable(false);
        }
    }
    return (
        <Popup isOpen={isOpen} title={title} onClose={onClose}>
            <div className='favourite'>
            {isLoading && <div className='w-100 d-flex justify-content-center'> <ListLoader/></div>}
                {
                    !isLoading ? gameList?.length > 0 ?
                        gameList?.map((game, ind) => {
                            return (
                                <div className={`${active && active?.includes(ind) ? "border-active" : ""}`} onClick={() => handlerClick(ind)}>
                                    <div className='overlay'>
                                        <span>     {game?.gameId?.name?.length > 20 ? (
                        <marquee>{game?.gameId?.name}</marquee>
                      ) : (
                        game?.gameId?.name
                      )}</span>
                                    </div>
                                    <img src={`${base_apis?.imageUrl}${game?.gameId.featuredImage.default}`} alt="game" />

                                </div>
                            )
                        }) : <>

<div className="d-flex justify-content-center align-items-center" style={{width:"100%",border:"none"}}> 
                        <span className="text-center">{t("common.no_data_found")}</span>
                        </div>
                        </> 
                     
                        : <></>
                }
            </div>
            <div className='mt-4'>
                {!isLoading ? gameList?.length > 0 ? <Button text={t("common.submit")} disabled={isSaveBtnDisable} onClick={handlerSubmit} /> : "" : ""}
            </div>
        </Popup>
    )
}

export default Favourite